import { Component, input, OnInit, inject } from '@angular/core';
import { ButtonComponent } from '../../../button/button.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { BackendService } from '../../../../api/bff/backend.service';
import { getFeedbackContext } from '../../../../utils/url/feedback-context';
import { NgStyle } from '@angular/common';
import { ModalService } from '../../../../state/modal/modal.service';
import { wildcardId } from '../../../../utils/feedback/feedback';
import { generalFormData } from './feedback';

@Component({
  selector: 'app-general-feedback',
  imports: [ButtonComponent, ReactiveFormsModule, NgStyle],
  templateUrl: './general-feedback.component.html',
  styleUrl: './general-feedback.component.css',
})
export class GeneralFeedbackComponent implements OnInit {
  private fb = inject(FormBuilder);
  private backend = inject(BackendService);
  private modalService = inject(ModalService);

  public showCloseButton = input(false);
  public form!: FormGroup;
  protected submitted = false;
  protected content = generalFormData.questions[0];

  ngOnInit() {
    this.form = this.fb.group({
      [this.content[0].id]: [null, Validators.required],
      consent: null,
    });
  }

  submitFeedback() {
    this.submitted = true;
    const consent = this.form.value.consent
      ? { hasConsented: true, description: this.content[1].id }
      : { hasConsented: false, description: '-' };
    firstValueFrom(
      this.backend.postFeedback({
        feature: 'general',
        context: getFeedbackContext(),
        rating: -1,
        consent,
        feedback: [
          {
            questionId: this.content[0].id,
            answer: [`${wildcardId}${this.form.value[this.content[0].id]}`],
          },
        ],
      }),
    );
    this.form.reset();
  }

  closeModal() {
    this.modalService.closeModal();
  }
}
